import { Component, ElementRef, inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { BookFeatureActivationService } from '../../../services/book-feature-activation.service';
import { SchoolbagFile } from '../../../models/schoolbag-file';
import { RouteService } from '../../../services/route.service';
import { ApplicationStateService } from '../../../services/application-state.service';
import { ModalService } from '../../../services/modal.service';
import { SidebarContentComponent } from '../../sidebar/sidebar/sidebar-content-component';
import { AbstractSidebarComponent } from '../../sidebar/sidebar/abstract-sidebar-component';
import { SidebarService } from '../../../services/sidebar.service';
import _ from 'lodash';
import { PageService } from '../../../services/page.service';
import { QuickLinkService } from '../../../services/quick-link.service';
import { CommunicationService } from '../../../services/communication.service';
import { HelpService } from '../../../services/help.service';
import { environment } from '../../../../environments/environment';
import { Subscription } from 'rxjs';
import { ModalableYedo } from '../../../models/modalable-yedo';
import { QuickLinkSignFormData } from '../../../models/quick-link-sign-form-data';
import { RestService } from '../../../services/rest.service';
import { ResponseStatus } from '../../../models/modalable';
import { QuickLinkType } from '../../../models/quick-link';
import { Materials } from '../../../models/materials';
import { MyBooksModalComponent } from '../../bookviewer/pages/modal-container/my-books-modal/my-books-modal.component';
import {
    AboutThisBookModalComponent
} from '../../bookviewer/pages/modal-container/about-this-book-modal/about-this-book-modal.component';
import {
    OfflineModeModalComponent
} from '../../bookviewer/pages/modal-container/offline-mode-modal/offline-mode-modal.component';
import { UserDataService } from '../../../services/user-data.service';
import { HomeworkService } from '../../../services/homework.service';
import { ModalComponent } from '../../../models/modal-component';
import { OfflineModeService } from '../../../services/offline-mode.service';
import {
    OfflineVersionModalComponent
} from '../../bookviewer/pages/modal-container/offline-version-modal/offline-version-modal.component';
import { CurrentModeComponent } from '../current-mode/current-mode.component';
import { AssetPipe } from '../../../pipes/asset.pipe';
import { BackgroundImageDirective } from '../../../directives/background-image.directive';
import { UserMenuComponent } from '../../sidebar/user-menu/user-menu.component';
import { ViewmodeSwitcherComponent } from '../viewmode-switcher/viewmode-switcher.component';
import { FeatureMenuComponent } from '../feature-menu/feature-menu.component';
import { CrudService } from '../../../services/crud.service';
import { TechnicalFeature } from '@lemberger/lemberger-am';
import { AccessibilityComponentDirective } from '../../../directives/accessibility-component.directive';
import { DigiTrainerComponent } from '../../sidebar/digi-trainer/digi-trainer.component';

@Component({
    selector: 'app-topbar',
    templateUrl: './topbar.component.html',
    styleUrls: ['./topbar.component.scss'],
    standalone: true,
    imports: [
        CurrentModeComponent,
        AssetPipe,
        BackgroundImageDirective,
        UserMenuComponent,
        ViewmodeSwitcherComponent,
        FeatureMenuComponent,
        AccessibilityComponentDirective
    ]
})
export class TopbarComponent extends AbstractSidebarComponent implements OnInit, OnDestroy {
    protected crudService = inject(CrudService);

    activeComponent: SidebarContentComponent;
    debouncedOnResize: (() => void) & _.Cancelable;
    coverURL: string;

    @ViewChild('buttonWrapper') buttonWrapper: ElementRef;
    showBookDropdown = false;

    aboutThisBookModalKey = AboutThisBookModalComponent;
    myBooksModalKey = MyBooksModalComponent;
    offlineVersionModalKey = OfflineVersionModalComponent;

    shownItems: Array<{
        component: SidebarContentComponent | string;
        icon: string;
        buttonHeight: string;
        iconSize: string;
        position: string;
        label: string;
        prominent?: boolean;
    }>;
    hiddenItems: Array<{
        component: SidebarContentComponent | string;
        icon: string;
        buttonHeight: string;
        iconSize: string;
        position: string;
        label: string;
        prominent?: boolean;
    }>;
    mobileTopbarMenuItem = [
        {
            component: 'openFaq',
            icon: 'sidebar/sidebar-icon-faq.png',
            buttonHeight: '50',
            iconSize: '25px',
            position: 'center 8px',
            label: 'FAQ',
            prominent: true
        },
        {
            component: this.ChapterContentComponent,
            icon: 'sidebar/sidebar-icon-kapitel.png',
            buttonHeight: '50',
            iconSize: '35px',
            position: 'center 8px',
            label: 'Kapitel'
        },
        {
            component: this.HomeworkComponent,
            icon: 'sidebar/sidebar-icon-hsm.png',
            buttonHeight: '50',
            iconSize: '35px',
            position: 'center 5px',
            label: 'HÜ/SÜ'
        },
        {
            component: this.NotesContentComponent,
            icon: 'sidebar/sidebar-icon-notizen.png',
            buttonHeight: '50',
            iconSize: '32px',
            position: 'center 5px',
            label: 'Notizen'
        },
        {
            component: this.SearchComponent,
            icon: 'sidebar/sidebar-icon-suche.png',
            buttonHeight: '50',
            iconSize: '20px',
            position: 'center 10px',
            label: 'Suche'
        },
        {
            component: this.PagesContentComponent,
            icon: 'sidebar/sidebar-icon-seiten.png',
            buttonHeight: '50',
            iconSize: '37px',
            position: 'center 6px',
            label: 'Seiten'
        },
        /*{
            component: 'help',
            icon: 'sidebar/sidebar-icon-hilfe.png',
            buttonHeight: '50',
            iconSize: '25px',
            position: 'center 2px',
            label: 'Hilfe'
        },*/
        {
            component: this.DigiTrainerComponent,
            icon: 'sidebar/sidebar-icon-digitrainer.png',
            buttonHeight: '50',
            iconSize: '25px',
            position: 'center 2px',
            label: 'digi.trainer'
        }
        /*{
            component: this.NotesContentComponent,
            icon: 'sidebar/sidebar-icon-dateien.png',
            buttonHeight: '50',
            iconSize: '25px',
            position: 'center 2px',
            label: 'Dateien'
        }*/
    ];
    mobileBooksContent = this.MobileBooksComponent;
    rsToggleImgSrc: string;
    rsTooltipText = 'Vorlesefunktion deaktiviert';
    env: any;

    mbookleImgSrc = 'button-mbook.png';
    wbookleImgSrc = 'button-wbook.png';
    yedoImgSrc = 'button-yedo.png';

    tooltipTimeout: any;
    rsSubscription: Subscription;
    digiTrainerSubscription: Subscription;
    animate = false;
    tooltipText = 'Offline-Version des Buches erstellen.';
    showOfflineVersionButton = false;

    private intervalId;

    constructor(
        public applicationStateService: ApplicationStateService,
        public routeService: RouteService,
        public featureActivationService: BookFeatureActivationService,
        protected modalService: ModalService,
        protected sidebarService: SidebarService,
        private quickLinkService: QuickLinkService,
        protected communicationService: CommunicationService,
        private helpService: HelpService,
        private homeworkService: HomeworkService,
        private pageService: PageService,
        private quicklinkService: QuickLinkService,
        private restService: RestService,
        private userDataService: UserDataService,
        public offlineModeService: OfflineModeService) {
        super();
        this.env = environment;
        this.debouncedOnResize = _.debounce(this.onResize, 50);

        // Remove HSM icon if book does not contain any HSM links
        if (this.quickLinkService.quickLinks.hsmQuickLinks.size === 0) {
            this.mobileTopbarMenuItem.splice(3, 1);
        }

        this.rsSubscription = this.communicationService.readspeakerVisibilityToggledSource$.subscribe(ele => {
            if (this.featureActivationService.readspeakerElementsVisible) {
                this.rsToggleImgSrc = 'button-audiobook-active.png';
                this.rsTooltipText = 'Vorlesefunktion<br/><strong>aktiviert</strong>';
            } else {
                this.rsToggleImgSrc = 'button-audiobook-inactive.png';
                this.rsTooltipText = 'Vorlesefunktion <br/><strong>deaktiviert</strong>';
            }
        });

        this.communicationService.offlineVersionCreatedAnnounced$.subscribe(() => {
            this.animate = true;

            setTimeout(() => {
                this.animate = false;
            }, 10000);
        });
    }

    /**
     * Called after component creation.
     */
    ngOnInit(): void {
        this.coverURL = this.pageService.getPageByIndex(0).image.url;
        // eslint-disable-next-line max-len
        if (this.featureActivationService.readspeakerElementsVisible) {
            this.rsToggleImgSrc = 'button-audiobook-active.png';
        } else {
            this.rsToggleImgSrc = 'button-audiobook-inactive.png';
        }

        this.mobileTopbarMenuItem = [];

        if (this.applicationStateService.bookConfig.quickLinkPrefix) {
            this.mobileTopbarMenuItem.push({
                component: 'openFaq',
                icon: 'sidebar/sidebar-icon-faq.png',
                buttonHeight: '50',
                iconSize: '25px',
                position: 'center 8px',
                label: 'FAQ',
                prominent: true
            });
        }

        // Only show HSM Button if HSM Quicklinks are available in the book.
        if (this.quickLinkService.quickLinks.hsmQuickLinks.size &&
            this.quickLinkService.quickLinks.genericQuickLinks.size) {
            this.mobileTopbarMenuItem.push({
                component: this.HomeworkComponent,
                icon: 'sidebar/sidebar-icon-hsm.png',
                buttonHeight: '50',
                iconSize: '35px',
                position: 'center 5px',
                label: 'HÜ/SÜ'
            });
        }

        this.mobileTopbarMenuItem = this.mobileTopbarMenuItem.concat([
            {
                component: this.NotesContentComponent,
                icon: 'sidebar/sidebar-icon-notizen.png',
                buttonHeight: '50',
                iconSize: '32px',
                position: 'center 5px',
                label: 'Notizen'
            },
            {
                component: this.SearchComponent,
                icon: 'sidebar/sidebar-icon-suche.png',
                buttonHeight: '50',
                iconSize: '20px',
                position: 'center 10px',
                label: 'Suche'
            },
            {
                component: this.PagesContentComponent,
                icon: 'sidebar/sidebar-icon-seiten.png',
                buttonHeight: '50',
                iconSize: '37px',
                position: 'center 6px',
                label: 'Seiten'
            }
            /*{
                component: 'help',
                icon: 'sidebar/sidebar-icon-hilfe.png',
                buttonHeight: '50',
                iconSize: '25px',
                position: 'center 2px',
                label: 'Hilfe'
            }*/
            /*{
                component: this.NotesContentComponent,
                icon: 'sidebar/sidebar-icon-dateien.png',
                buttonHeight: '50',
                iconSize: '25px',
                position: 'center 2px',
                label: 'Dateien'
            }*/
        ]);
        this.digiTrainerSubscription = this.quicklinkService.digiTrainerContent$.subscribe(
            result => {
                this.mobileTopbarMenuItem = this.mobileTopbarMenuItem.filter(item => !(item.component instanceof DigiTrainerComponent));
                if (result) {
                    const digiTrainerItem = {
                        component: this.DigiTrainerComponent,
                        icon: 'sidebar/sidebar-icon-digitrainer.png',
                        buttonHeight: '50',
                        iconSize: '25px',
                        position: 'center 2px',
                        label: 'digi.trainer'
                    };
                    this.mobileTopbarMenuItem.push(digiTrainerItem);
                }
                this.onResize();
            }
        );
        this.onResize();

        this.showOfflineVersionButton = !this.applicationStateService.isOfflineModeEnabled
            && this.applicationStateService.userData.loggedIn
            && this.userDataService.hasBookAccessCode();
    }

    ngOnDestroy(): void {
        this.digiTrainerSubscription.unsubscribe();
        this.rsSubscription.unsubscribe();
    }

    /**
     * Transforms the date of the schoolbag file into an Date object.
     * @param {SchoolbagFile} schoolBagFile
     * @returns {Date}
     */
    getDateOfFile(schoolBagFile: SchoolbagFile): Date {
        return new Date(schoolBagFile.uploadedAt.replace(' ', 'T')
            .substr(0, 19));
    }

    openModal(modalKey: ModalComponent): void {
        if (this.applicationStateService.isOfflineModeEnabled) {
            this.modalService.openModal(OfflineModeModalComponent);

            return;
        }
        this.modalService.openModal(modalKey);
    }

    openMaterialsModal(): void {
        if (this.applicationStateService.isOfflineModeEnabled) {
            this.modalService.openModal(OfflineModeModalComponent);

            return;
        }

        const materialModal = new Materials();
        materialModal.bypassCheck = this.applicationStateService.userData.isTeacher;

        this.modalService.openModal(materialModal);
    }

    openOfflineVersionModal(): void {
        if (this.applicationStateService.isOfflineModeEnabled) {
            this.modalService.openModal(OfflineModeModalComponent);

            return;
        }

        if (this.applicationStateService.bookConfig.offlineVersionCreatable
            && this.offlineModeService.check === undefined) {
            this.offlineModeService.getOfflineVersion();
            this.checkOfflineVersionProgress();
        }
        // Force hiding tooltip because the event never makes it to bootstrap
        ($('#offlineVersionButton').closest('[data-bs-toggle="tooltip"]') as any).tooltip('hide');

        this.modalService.openModal(OfflineVersionModalComponent);
    }

    openBookInfoModal(): void {
        this.modalService.openModal(this.aboutThisBookModalKey);
    }

    onResize(): void {
        const singleTopbarItemWidth = 60;
        const containerWidth = this.getButtonWrapperWidth();

        // Container might not be available at the moment
        if (containerWidth < 0) {
            this.debouncedOnResize();
        }

        const containerSpace = (containerWidth - 20) - singleTopbarItemWidth;
        let countShown = Math.trunc(containerSpace / singleTopbarItemWidth);
        // prevent a dropdown with only one item
        if (countShown === this.mobileTopbarMenuItem.length - 1) {
            countShown++;
        }
        this.shownItems = this.mobileTopbarMenuItem.slice(0, countShown);
        this.hiddenItems = this.mobileTopbarMenuItem.slice(countShown);
    }

    // TODO: Implement to prevent closing the overlay
    stopPropagation($event: UIEvent): void {
        $event.stopPropagation();

    }

    toggleBookDropdown(): void {
        this.showBookDropdown = !this.showBookDropdown;
    }

    toggleReadspeaker(): void {
        this.featureActivationService.readspeakerActivated = !this.featureActivationService.readspeakerActivated;
        this.featureActivationService.readspeakerElementsVisible = !this.featureActivationService.readspeakerElementsVisible;
        this.communicationService.toggleReadspeakerVisibility();
        if (this.featureActivationService.readspeakerElementsVisible) {
            this.rsToggleImgSrc = 'button-audiobook-active.png';
            this.rsTooltipText = 'Vorlesefunktion<br/><strong>aktiviert</strong>';
        } else {
            this.rsToggleImgSrc = 'button-audiobook-inactive.png';
            this.rsTooltipText = 'Vorlesefunktion <br/><strong>deaktiviert</strong>';
        }

        if (this.tooltipTimeout) {
            clearTimeout(this.tooltipTimeout);
        }

        ($('.rs-toggle-button') as any).tooltip('dispose')
            .tooltip({ title: this.rsTooltipText })
            .tooltip('show');

        this.tooltipTimeout = setTimeout(() => {
            ($('.rs-toggle-button') as any).tooltip('hide');
        }, 1500);
    }

    async openComponentInSidebar(sidebarContentComponent: SidebarContentComponent | string): Promise<void> {

        if (sidebarContentComponent === 'openFaq') {
            const faqURL = this.routeService.getAbsoluteRoute('faq', {});
            window.open(faqURL, '_blank');

            return;
        }

        if (sidebarContentComponent === 'help') {
            this.helpService.openHelp();

            return;
        }

        if (!await this.homeworkService.checkAlert()) {
            return;
        }
        super.openComponentInSidebar(sidebarContentComponent);
        this.showBookDropdown = false;
    }

    wbook(): void {
        this.wbookleImgSrc = 'button-wbook.png';
    }

    wbookHover(): void {
        this.wbookleImgSrc = 'button-wbook-hover.png';
    }

    mbook(): void {
        this.mbookleImgSrc = 'button-mbook.png';
    }

    mbookHover(): void {
        this.mbookleImgSrc = 'button-mbook-hover-active.png';
    }

    yedo(): void {
        this.yedoImgSrc = 'button-yedo.png';
    }

    yedoHover(): void {
        this.yedoImgSrc = 'button-yedo-hover.png';
    }

    openQuicklinkModal(): void {
        const secondPage = this.pageService.getCurrentPages().length > 1;

        let quicklink = this.quicklinkService.getFirsQuickLinkOfPage(this.pageService.getCurrentPages()[0].id);
        if (!quicklink && secondPage) {
            quicklink = this.quicklinkService.getFirsQuickLinkOfPage(this.pageService.getCurrentPages()[1].id);
        }
        if (!quicklink) {
            return;
        }

        this.quicklinkService.openQuicklink(quicklink);
    }

    openYedoSignModal(): void {
        const secondPage = this.pageService.getCurrentPages().length > 1;
        let quicklink = this.quicklinkService.getFirstQuickLinkOfPageAndType(this.pageService.getCurrentPages()[0].id, QuickLinkType.YEDO);
        if (!quicklink && secondPage) {
            quicklink = this.quicklinkService.getFirstQuickLinkOfPageAndType(this.pageService.getCurrentPages()[1].id, QuickLinkType.YEDO);
        }

        if (quicklink) {
            this.quicklinkService.openQuicklink(quicklink);

            return;
        }

        const $modal = new ModalableYedo();
        const route = this.routeService.getRelativeRoute(environment.endpointUrls.quicklinkSignYedo, {
            bookId: this.applicationStateService.bookId
        });

        $modal.bypass = true;
        $modal.status = ResponseStatus.ACCESSIBLE;
        this.modalService.openModal($modal);

        this.crudService.logDirect(TechnicalFeature.Yedo);

        this.restService.post(route, { target: quicklink?.redirect }).then(result => {
            $modal.formData = result as QuickLinkSignFormData;
        }).catch(error => {
            if (error.status === 401 || error.status === 403) {
                $modal.status = ResponseStatus.NOT_ACCESSIBLE;
                this.modalService.closeModal($modal.getModalId());
                $modal.bypass = false;
                this.modalService.openModal($modal);
            } else {
                $modal.status = ResponseStatus.ERROR;
            }
        });
    }

    goToMbookPage(): void {
        this.pageService.getCurrentRealPageNumbers().then(value => {
            window.open(this.routeService.getmBookLink(value[0]), '_blank');
        });
    }

    private getButtonWrapperWidth(): number {
        if (this.buttonWrapper && this.buttonWrapper.nativeElement) {
            return this.buttonWrapper.nativeElement.clientWidth;
        }

        return -1;
    }

    private checkOfflineVersionProgress(): void {
        this.intervalId = setInterval(() => {

            if (!this.offlineModeService.check) {
                this.offlineModeService.updateProgress();

                return;
            }

            const $offlineVersionButton = $('#offlineVersionButton');
            if (this.offlineModeService.check.available) {
                clearInterval(this.intervalId);

                this.tooltipText = 'Die Offline-Version ist bereit für den Download.';
                $offlineVersionButton.attr('data-bs-original-title', this.tooltipText);

                return;
            }

            this.tooltipText = 'Die Offline-Version wird vorbereitet.';
            $offlineVersionButton.attr('data-bs-original-title', this.tooltipText);

            this.offlineModeService.updateProgress();
        }, 2000);
    }
}
